module.exports = __webpack_public_path__ + "static/media/ApercuPro.d8db5882.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/components/customFont/font5/ApercuPro.woff2
// module id = 356
// module chunks = 0